import type { TypePolicies } from '@apollo/client';

export const Page: TypePolicies['Page'] = {
  keyFields: ['id', 'documentId'],
};

export const Input: TypePolicies['Input'] = {
  keyFields: ['id', 'documentId'],
};
